const ARMOR_PIECES = [
  { id: "head", name: "Head", category: "minor" },
  { id: "arms", name: "Arms", category: "minor" },
  { id: "body", name: "Body", category: "major" },
  { id: "legs", name: "Legs", category: "major" },
];

const ARMOR_QUALITIES = {
  major: [
    { id: "none", name: "None", ar: 0, mar: 0, detriment: 0 },
    { id: "light_simple", name: "Light Simple", ar: 1, mar: 0, detriment: 0 },
    { id: "light_standard", name: "Light Standard", ar: 2, mar: 0, detriment: 0 },
    { id: "light_great", name: "Light Great", ar: 2, mar: 1, detriment: 0 },
    { id: "light_master", name: "Light Master", ar: 3, mar: 1, detriment: 0 },
    { id: "heavy_simple", name: "Heavy Simple", ar: 2, mar: 1, detriment: 1 },
    { id: "heavy_standard", name: "Heavy Standard", ar: 3, mar: 1, detriment: 1 },
    { id: "heavy_great", name: "Heavy Great", ar: 4, mar: 2, detriment: 1 },
    { id: "heavy_master", name: "Heavy Master", ar: 5, mar: 2, detriment: 1 },
  ],
  minor: [
    { id: "none", name: "None", ar: 0, mar: 0, detriment: 0 },
    { id: "light_simple", name: "Light Simple", ar: 1, mar: 0, detriment: 0 },
    { id: "light_standard", name: "Light Standard", ar: 1, mar: 0, detriment: 0 },
    { id: "light_great", name: "Light Great", ar: 2, mar: 0, detriment: 0 },
    { id: "light_master", name: "Light Master", ar: 2, mar: 1, detriment: 0 },
    { id: "heavy_simple", name: "Heavy Simple", ar: 2, mar: 0, detriment: 1 },
    { id: "heavy_standard", name: "Heavy Standard", ar: 2, mar: 1, detriment: 1 },
    { id: "heavy_great", name: "Heavy Great", ar: 3, mar: 1, detriment: 1 },
    { id: "heavy_master", name: "Heavy Master", ar: 3, mar: 2, detriment: 1 },
  ],
};

const SHIELD_TYPES = [
  { id: "none", name: "None", ar: 0, blockBonus: 0, detriment: 0 },
  { id: "light_simple", name: "Light Simple", ar: 0, blockBonus: 1, detriment: 0 },
  { id: "light_standard", name: "Light Standard", ar: 1, blockBonus: 1, detriment: 0 },
  { id: "light_great", name: "Light Great", ar: 2, blockBonus: 1, detriment: 0 },
  { id: "light_master", name: "Light Master", ar: 3, blockBonus: 1, detriment: 0 },
  { id: "heavy_simple", name: "Heavy Simple", ar: 2, blockBonus: 2, detriment: 1 },
  { id: "heavy_standard", name: "Heavy Standard", ar: 3, blockBonus: 2, detriment: 1 },
  { id: "heavy_great", name: "Heavy Great", ar: 4, blockBonus: 2, detriment: 1 },
  { id: "heavy_master", name: "Heavy Master", ar: 5, blockBonus: 2, detriment: 1 },
];

export {ARMOR_PIECES, ARMOR_QUALITIES, SHIELD_TYPES}
